import axios from 'axios';

export interface Admin {
  id: string;
  email: string;
  name?: string;
  created_at: string;
  updated_at: string;
}

export interface CheckAdminResponse {
  isAdmin: boolean;
}

export interface CreateAdminDto {
  email: string;
  name?: string;
}

const getBaseUrl = () => {
  return import.meta.env.VITE_API_URL ?? 'http://localhost:3001/api';
};

/**
 * Check if the current user is an admin
 */
export async function checkIsAdmin(token: string): Promise<boolean> {
  try {
    const response = await axios.get<CheckAdminResponse>(`${getBaseUrl()}/admins/check`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.isAdmin;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

/**
 * Get all admins
 */
export async function listAdmins(token: string): Promise<Admin[]> {
  const response = await axios.get<Admin[]>(`${getBaseUrl()}/admins`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

/**
 * Create a new admin
 */
export async function createAdmin(token: string, data: CreateAdminDto): Promise<Admin> {
  const response = await axios.post<Admin>(`${getBaseUrl()}/admins`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

/**
 * Delete an admin
 */
export async function deleteAdmin(token: string, id: string): Promise<void> {
  await axios.delete(`${getBaseUrl()}/admins/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
